module.exports = __webpack_public_path__ + "img/南宁新畅行汽车市场管理有限公司.3c86ebc9.jpg";